import { instance2 } from "App/constants";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_RUANG_RS_OL = {
  id: "",
  name: "",
  kode: "",
  remark: "",
};

export const urlGetList = LIST_URL_MASTER.ruang_rs_online.list;
export const urlAddRuang = LIST_URL_MASTER.ruang_rs_online.add;
export const urlUpdateRuang = LIST_URL_MASTER.ruang_rs_online.update;
export const urlDeleteRuang = LIST_URL_MASTER.ruang_rs_online.delete;

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
    minWidth: "55px",
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "90px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "70px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "100px",
  },
];

/* FOR ENDPOINT */
export const deleteRuangRsOlById = async (id) => {
  try {
    return instance2.delete(urlDeleteRuang, {
      data: { id: id },
    });
  } catch(error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
}

